import getChallengeInfoById from "./getChallengeInfoById";
import bqGetChallengeSummary from "./bqGetChallengeSummary";
import setChallengeInfo from "./setChallengeInfo";
import moment from "moment";
const getChallengeSummary = async function(competition_id, startDate, endDate) {
  const summaryData = await bqGetChallengeSummary(competition_id, startDate, endDate);
  //update summary data
  if( summaryData.recal ){
    const challengeUpdated = {
      summaryDate: moment(new Date(), "YYYY-MM-DD").subtract(1, "days").toDate(),
      summary: summaryData
    };
    await setChallengeInfo(competition_id, challengeUpdated);
  }
  return await getChallengeInfoById(competition_id);
};

export default getChallengeSummary;
